export const environment = {
  production: false,
  apiUrl: 'https://taxora-backend-dev.onrender.com',
  appName: 'Taxora Accountant',
  version: '1.0.0',
};
